import React from "react";
import { Collapse } from "@mui/material";

// Shows or hides a dashboard widget or card with a height animation, then unmounts it.
// `fill` keeps a grid item stretched to its row height; `style` places it in the grid.
// MUI skips the motion for reduced-motion users.
const WidgetGate = ({ show = true, fill = false, style, children }) => (
  <Collapse
    in={show}
    mountOnEnter
    unmountOnExit
    timeout={{ enter: 260, exit: 200 }}
    style={style}
    sx={fill ? { "&.MuiCollapse-entered": { height: "100%" }, "& .MuiCollapse-wrapper, & .MuiCollapse-wrapperInner": { height: "100%" } } : undefined}
  >
    <div style={fill ? { height: "100%", display: "grid" } : undefined}>{children}</div>
  </Collapse>
);

export default WidgetGate;
